/* eslint-disable no-prototype-builtins */
XPortal.Grid = (function () {
    var self = {
        multipleValueGridSeparator: ",",
        requestDebounceMs: 500,
        defaultViews: [],
        selectedRecords: [],
        AssignedNotificationsItems: [],
        dictionaryParent: {},
        customFormats: {},
        showDebugInfo: false,
        isDarkTheme: document.body.classList.contains('theme-dark'),
        ShowGrid: function (gridEl) {
            var ginfo = self.GetGridInfo(gridEl);
            if (!ginfo.parent || !ginfo.kgrid) return;
            ginfo.parent.is(':visible') && self.ResizeGrid(ginfo.grid);
            ginfo.parent.addClass('show');

            XPortal.DropdownBtns.gridButtons.init(ginfo.actionsHeader);

            if (XPortal.Main.GridVisibleNumber > 0 && XPortal.Utils.isElementVisible(ginfo.parent))
                XPortal.Main.GridVisibleNumber--;
            updateGridSize();
            if (XPortal.Main.GridVisibleNumber == 0)
                $('.content-wrapper').addClass('show');
        },
        ExtendRequestedParams: function (page, data, groupsInfo, schemamodel, keywords, listFacets, treeFacets) {
            var self = this;
            var result = jQuery.extend({ pageIndex: data.page, facets: [] }, page, data);
            var i = 0;
            if (data.sort || (groupsInfo && groupsInfo.length)) {
                delete result.sort;
                result.sort = [];
            }
            if (groupsInfo) {
                for (var i = 0; i < groupsInfo.length; i++) {
                    let sortFld = groupsInfo[i].field.toLowerCase();
                    sortFld = sortFld.indexOf(this.normalizeFieldPrefix) == 0 ? sortFld.slice(self.normalizeFieldPrefix.length) : sortFld;
                    sortFld = sortFld.indexOf("srt_") == 0 ? sortFld.slice(4) : sortFld;
                    result.sort.push({ name: "srt_" + sortFld, dir: groupsInfo[i].dir });
                }
            }
            if (data.sort) {
                for (var i = 0; i < data.sort.length; i++) {
                    let sortFld = data.sort[i].field.toLowerCase();
                    sortFld = sortFld.indexOf(this.normalizeFieldPrefix) == 0 ? sortFld.slice(self.normalizeFieldPrefix.length) : sortFld;
                    sortFld = sortFld.indexOf("srt_") == 0 ? sortFld.slice(4) : sortFld;
                    result.sort.push({ name: "srt_" + sortFld, dir: data.sort[i].dir });
                }
            }

            if (listFacets) result.facets = listFacets;
            if (treeFacets) result.treeFacets = treeFacets;

            if (data.filter) {
                var actualfilters = _.filter(data.filter.filters.filter(f => f != null), function (filter) {
                    if (filter.field.indexOf(self.normalizeFieldPrefix) === 0) filter.field = filter.field.slice(self.normalizeFieldPrefix.length);
                    if ($.type(filter.value) === "string") filter = patchFilter(filter, schemamodel);

                    if (filter.value instanceof Date) {//General type

                        var filterFieldTypeLC = schemamodel.fields[filter.field].type.toLowerCase();
                        var siteFormat = schemamodel.siteformats.find(item => item.type.toLowerCase() == filterFieldTypeLC);

                        if (filterFieldTypeLC == "datetime") {
                            //DateTime field type
                            var tmpDTFormat = siteFormat && siteFormat.format ? siteFormat.format : null;
                            var val = XPortal.Utils.TransformDateTime(filter.value, tmpDTFormat, true, false, true, false);
                            delete filter.value;
                            filter.value = moment.utc(val.format("YYYY-MM-DDTHH:mm:ss")).format();
                        } else {
                            //Date filed type
                            if (siteFormat && siteFormat.format) {
                                if (moment(filter.value, siteFormat.format, true).isValid()) filter.value = moment(filter.value).toDate();
                            }
                            var val = filter.value;
                            delete filter.value;
                            filter.value = XPortal.Utils.customISOstring(val, val.getTimezoneOffset());
                        }
                    }
                    if (filter.field === "__keywords") result["keywords"] = filter.value;
                    if (filter.additionalType == "period" && (filter.filters || []).length > 0) filter.field = "";
                    return filter.field !== "__keywords";
                });
                data.filter.filters = actualfilters;
            }
            if (keywords) result["keywords"] = keywords;
            return result;
        },
        MapEntity: function (di, options) {
            if (di.Json) {
                if (di.Json.indexOf("[{") > -1) di.Fields = JSON.parse(di.Json);
                else di.Fields = JSON.parse(di.JsonDecrypted ? di.Json : XPortal.Utils.unzipToJson(di.Json));
            }
            if (options && options.data && options.data.sort && options.data.sort.length > 0) {
                _.each(options.data.sort, function (sortField) {
                    if (!di.Fields.find(f => f.Name.toLowerCase() == sortField.field.toLowerCase())) {
                        di.Fields.push({ Name: sortField.field, StringValue: "", Type: "String" });
                    };
                });
            };
            var downloadCols = options && options.columns ? options.columns.filter(c => c.format && c.format.includes('class="download"')).map(c => c.field) : [];
            var fakeColumns = options && options.columns ? options.columns.filter(c => c.field && c.field.length > 3 && c.field.substr(0, 3) == "_f_").map(c => c.field) : [];
            _.each(fakeColumns, function (fcfi) { di[fcfi] = ""; });
            var groupedFields = _.groupBy(di.Fields, "Name");
            _.each(groupedFields, function (gpi) {
                var pi = gpi[0];
                if (gpi.length > 1) {
                    pi.StringValue = _.pluck(gpi, "StringValue").join(XPortal.GridInlineEditing.ValueSeparator);
                    pi.ismultiselect = true;
                    gpi.forEach(function (fld, ind) { if (ind > 0) fld.toRemove = true; });
                }
                var fieldName = pi.Name.toLowerCase();
                var nFieldName = Number(fieldName[0]) > 0 ? self.normalizeFieldPrefix + fieldName : fieldName;//some fiedls could start with numbers
                if (fieldName == "uniqueid") {
                    if (!pi.hasOwnProperty("StringValue")) pi.StringValue = di[pi.Name];
                } else if (fieldName == "createdby") di.IsOwnRecord = XPortal.Account.IsSame(pi.StringValue);
                if (fieldName.indexOf(self.normalizeFieldPrefix) !== 0) {
                    delete di[fieldName];
                    if (pi.Name !== "UniqueId") { //since we use UniqueId widely i will leave this field
                        delete di[pi.Name];
                    }
                }
                if ((pi.StringValue !== "" || downloadCols.indexOf(nFieldName) < 0) && fieldName.indexOf(self.normalizeFieldPrefix) !== 0) {
                    di[nFieldName] = pi.StringValue;
                }
                var ltype = (pi.Type ? pi.Type.toLowerCase() : "");
                if (ltype == "int" || ltype == "int32" || ltype == "int64" || ltype == "decimal" || ltype == "i" || ltype == "d") {
                    if (Array.isArray(di[nFieldName])) di[nFieldName] = di[nFieldName].length > 0 ? di[nFieldName][0] : "";
                    di[nFieldName] = XPortal.Grid.ConvertToNumber(di[nFieldName], pi, di, pi.Name);
                }
                if (ltype == "date" || ltype == "datetime" || ltype == "dd" || ltype == "dt") {
                    if (Array.isArray(di[nFieldName])) di[nFieldName] = di[nFieldName].length > 0 ? di[nFieldName][0] : "";

                    if (di[nFieldName] === "") di[nFieldName] = null;
                    if (ltype == "datetime" || ltype == "dt") {
                        var utcValue = di[nFieldName]; // server value is UTC; model stays UTC, only the display Date is shifted to member-local
                        di[nFieldName] = utcValue === null ? null : XPortal.Utils.AdjustDT(utcValue, true);
                        if (di[nFieldName]) {
                            if (moment(di[nFieldName]).isValid()) {
                                let isoUTC = moment.utc(utcValue).toISOString();
                                pi.StringValue = isoUTC.substr(0, isoUTC.length - 5);
                            } else pi.StringValue = di[nFieldName];
                        }
                        else pi.StringValue = "";
                    }
                    else {
                        var tmpDateVal = di[nFieldName];
                        if (tmpDateVal && tmpDateVal.length > 0) {
                            tmpDateVal = XPortal.Utils.TransformDateTime(tmpDateVal, "YYYY-MM-DD", false, false, false, false, false);
                            tmpDateVal = XPortal.Grid.ConvertToDate(tmpDateVal, null);
                        }
                        di[nFieldName] = tmpDateVal && typeof tmpDateVal.toDate === "function" ? tmpDateVal.toDate() : (tmpDateVal ? tmpDateVal : null);
                        pi.StringValue = di[nFieldName] ? moment(di[nFieldName]).format("YYYY-MM-DD") : "";
                    }
                }
                if (ltype == "bool" || ltype == "boolean") {
                    if (Array.isArray(di[nFieldName])) di[nFieldName] = di[nFieldName].length > 0 ? di[nFieldName][0] : "";
                    di[nFieldName] = XPortal.Grid.ConvertToBoolean(pi.StringValue && pi.StringValue.toLowerCase ? pi.StringValue.toLowerCase() : "", pi, di, pi.Name);
                }
            });
            di.Fields = di.Fields.filter(f => f.toRemove !== true);

            var pageSize = options && options.data ? options.data.pageSize : 0;
            if (pageSize > 1000) {//optimize performance
                //var filterbycolumns = options.columns;
                di.Json = "";
                di.Fields = pageSize % 100 !== 0 ? [] : di.Fields;
            }
            return di;
        },
        ConvertToKendoData: function (result, options, sttgs) {
            if (result.State < 0) {
                if (options.error) options.error(result.Errors[0]);
                return [];
            };
            options.columns = sttgs.columns;
            var data = !(result.Result) ? [] : result.Result.Items.map(di => XPortal.Grid.MapEntity(di, options));
            data.columns = sttgs.columns;
            data.total = !(result.Result) ? 0 : result.Result.TotalItems;
            return data;
        },
        ConvertToBoolean: function (src, pi, di, pname) {
            if (src == "1" || src == "true") return true;
            if (src == "0" || src == "false") return false;
            return Boolean(src);
        },
        ConvertToNumber: function (src, pi, di, pname) {
            if (!src || src == "") return src;
            var nbr = Number(src);
            if (isNaN(nbr)) return src;
            return nbr;

        },
        ConvertToDate: function (src, frmt, skipFormat, returnNullIfError, returnMomentObject = false, simpleDateAsUTC = false) {
            if (!src || src == "") return src;
            frmt = frmt ? XPortal.Template.formatDateToMomment(frmt) : "YYYY-MM-DD";
            var mmnt = skipFormat ? moment(src) : moment(src, frmt);
            if (!mmnt.isValid()) mmnt = moment(src);
            if (!mmnt.isValid()) return returnNullIfError ? null : src;
            return mmnt.toDate();
        },
        ConvertDateToString: function (d) {
            var finalResult = XPortal.Utils.TransformDateTime(d, "YYYY-MM-DD", false, true, false);
            if (finalResult && finalResult.toString().length > 0)
                return finalResult;

            return d;
        },
        numericTypes: ["int", "int32", "int64", "long", "number", "decimal", "float"],
        GetTemplateValue: function (d, dtype, dfield, inFormat, pageInfo, notWrapCellContent, subType) {
            dfield = dfield ? decodeURIComponent(dfield) : dfield;
            inFormat = inFormat ? decodeURIComponent(inFormat) : inFormat;
            var fvalue = d[dfield];
            if (fvalue === null) {
                for (var i in d) {
                    if (i.toLowerCase() == dfield) {
                        fvalue = d[i]; break;
                    }
                }
            }
            var lookupValue = d[dfield + "___value___"] || d[dfield + "___Value___"];
            if (lookupValue != null) fvalue = lookupValue;


            var fvals = fvalue && fvalue["length"] && fvalue["pop"] ? fvalue : [fvalue];
            var r = _.map(fvals, function (x) {
                fvalue = x;

                if (dtype === "string") fvalue = XPortal.Format.FormatMultipleValue(fvalue);
                var dformat = inFormat;
                if (inFormat && (inFormat.indexOf("[[") >= 0 || inFormat.indexOf("##") >= 0))
                    dformat = XPortal.Template.ReplaceFormatString(inFormat, fvalue, d, pageInfo, dfield);
                if (dformat && (dformat.indexOf("#=") >= 0 || dformat.indexOf("#:") >= 0))
                    dformat = XPortal.Template.ApplyKendoTemplate(d, dformat, dformat === inFormat);

                if (dformat && dformat.indexOf("script:") > -1) {
                    try {
                        let formatScript = dformat.substr(dformat.indexOf("script:") + 7, dformat.length);
                        fvalue = eval(formatScript);
                        dformat = "";
                    }
                    catch (e) { dformat = ""; }
                }
                if (dtype == "bool" || dtype == "boolean") return XPortal.Template.boolean(dformat, fvalue == "true" ? true : fvalue == "false" ? false : fvalue, d, dfield, pageInfo);
                if (fvalue == null || fvalue == '') {
                    if (dformat && dformat.indexOf('download') > -1) {
                        var defaultText = $(dformat).data('no-files-text');
                        if (typeof defaultText !== 'undefined' && defaultText !== '') {
                            return '<span class="upload-field-default-text">' + defaultText + '</span>';
                        }
                    }
                }
                if (inFormat && (inFormat.indexOf("[[") >= 0 || inFormat.indexOf("##") >= 0 || inFormat.indexOf("#=") >= 0 || inFormat.indexOf("#:") >= 0))
                    return dformat;
                if (fvalue == null) return XPortal.Template.numeral(dformat, '', d, dfield, pageInfo);
                if (dtype == "date") return XPortal.Template.date(dformat, fvalue, d, dfield, pageInfo);
                if (dtype == "datetime") return XPortal.Template.datetime(dformat, fvalue, d, dfield, pageInfo);
                if (dtype == "base64" || (dtype === 'string' && subType === 'FileLink')) return XPortal.Template.base64(dformat, fvalue, d, dfield, pageInfo);

                if (XPortal.Grid.numericTypes.indexOf(dtype) > -1)
                    return XPortal.Template.numeral(dformat, fvalue, d, dfield, pageInfo);
                return dformat && dformat.length > 0 ? kendo.format(dformat, fvalue) : fvalue;
            }).join(", ");
            var dsFormat = self.ExtendedFormat(pageInfo, dfield);
            if (dsFormat && dsFormat.formatExtended) return self.WrapCellExtended(dsFormat, r, d, pageInfo, dfield);
            return notWrapCellContent ? r : XPortal.Grid.WrapCellContent(r);
        },
        WrapCellContent: function (content) {
            return "<span class=\"tdcell\">" + content + "</span>";
        },
        WrapCellExtended: function (dsFormat, content, data, nodeid, field) {
            return "<span class=\"tdcell\">" + content + "</span>";
        },
        AdjustSchemaModelInfo: function (gridEl, dsField, column, formats, cpage) {
            self.ExtendedFormat(cpage.nodeId, column.field, dsField);
            dsField.type = dsField.convertor.toLowerCase().trim();

            dsField.validation = dsField.validation || {};
            dsField.validation.jQueryValidate = columnJQueryValidate;

            if (!dsField.type || !dsField.type.length) dsField.type = "string";
            if (dsField.type == "timestamp") dsField.type = "time";
            var numericTypes = ["int", "int32", "int64", "long", "number", "decimal", "float"];
            if (numericTypes.indexOf(dsField.type) > -1) dsField.type = "number";

            if (dsField.convertorformat && dsField.convertorformat != "" && dsField.convertorformat.length > 0) {
                dsField.format = (dsField.convertorformat.indexOf("script:") > -1 || dsField.type == "number") ? dsField.convertorformat : "{0:" + dsField.convertorformat + "}";
            }
            if (dsField.format && dsField.format.length > 0) {
                if (column && (!column.format || column.format == '')) column.format = dsField.format;
            }
            if (!column) return dsField;
            if (Number(column.isdetail) == 1 || Number(dsField.isdetail) == 1) {
                column.format = "<a href='" + cpage.details.url + "?id=[[UniqueId]]&r=[[newguid]]' style='width:100%'>{0}</a>";
            }
            if (dsField.convertorformat == "n2")
                column.format = "{0:" + dsField.convertorformat + "}";
            column.attributes = column.attributes ? column.attributes : {};

            column.attributes["data-ctype"] = dsField.type;
            column.attributes["data-cfield"] = column.field;
            column.attributes["alignment"] = column.alignment;
            if (dsField.formatExtended)
                column.template = '#=' + dsField.formatExtended.Method + '(data,"' + (dsField.type) + '","' + encodeURIComponent(dsField.field) + '","' + encodeURIComponent(column && column.format ? column.format.replace(/\"/g, '\\"') : '') + '",' + cpage.nodeId + ')#';
            else
                column.template = '#=XPortal.Grid.GetTemplateValue(data,"' + (dsField.type || "string") + '","' + encodeURIComponent(dsField.field || "") + '","' + encodeURIComponent(column && column.format ? column.format.replace(/\"/g, '\\"') : '') + '",' + cpage.nodeId + ', null, "' + column.subType + '")#';
            XPortal.Grid.BindEditors(dsField, column);

            if (column.aggrigationsInfo && column.aggrigationsInfo.length > 0)
                column.footerTemplate = () => XPortal.Grid.Aggregation.GetFooterColumnTemplate(column.field, column.aggrigationsInfo, gridEl);
            return dsField;
        },
        BindEditors: function (field, column) {
            var uiFilter = null;
            if (field.type == "date" && field.convertorformat && field.convertorformat != "" && field.convertorformat.length > 0) {
                uiFilter = function (element) {
                    element.kendoDatePicker({
                        format: field.format,
                        parseFormats: ["dd-MM-yyyy", "dd-MM-yy", "dd-MM-yyyy", "dd/MM/yy", "dd/MM/yyyy", "dd MM yyyy", "dd-MM", "dd/MM", "dd MM"]
                    });
                };
            }
            if (uiFilter) {
                if (!column.filterable) column.filterable = {};
                column.filterable.ui = uiFilter;
            }
        },
        ProccessError: function (options, jqXHR, textStatus, errorThrown) {
            options.error(jqXHR, textStatus, errorThrown);
        },
        InitChildContentTable: function (e, nodeids, containerselector, templateSelector) {
            _.each(nodeids, function (nid) {
                var template = jQuery(templateSelector + nid);
                var templateParent = template.closest(".grid-parent");
                var container = jQuery(e.detailCell).find(containerselector + nid);
                var exists = container.text().trim() == null && container.attr("data-init") != "1";
                container.attr("data-init", "1");
                var templateParentC = templateParent.clone();
                templateParentC.appendTo(container);

                var tblGgridEl = templateParentC.find(".kendo-cdetail-grid");
                tblGgridEl.attr("id", "tmp_" + window.UUID.generate());

                var grcolumns = null;
                var pageinfo = null;
                var caccess = null;
                eval("grcolumns=" + templateParent.find(".grid-columns").html());
                eval("caccess=" + templateParent.find(".grid-columns-access").html());
                var pinfo = String(templateParent.find(".grid-columns-page").html());
                if (pinfo && pinfo.length > 0) eval("pageinfo=" + pinfo); else pinfo = {};
                var childaliases = container.attr("data-alias");
                childaliases = childaliases && childaliases.length > 0 ? childaliases.toLowerCase() : "";
                var dataitems = [];
                var fields = _.filter(e.data.Fields ? e.data.Fields : [], function (r) {
                    if (r.Type && r.Type.toLowerCase() == childaliases)
                        return true;
                    else
                        return false;
                });
                _.each(fields, function (r) {
                    if (r.StringValue && r.StringValue.length > 0)
                        dataitems.push({ Json: r.StringValue });
                    else
                        dataitems.push({});
                });
                XPortal.Grid.Init(tblGgridEl, grcolumns, caccess, pageinfo, dataitems, true);

            });
        },
        InitSelectableGrid: function (igrid, settings, viewSettings) {            
            let ginfo = self.GetGridInfo($(igrid));
            const modelPath = XPortal.Store.GetModelPath($("#" + ginfo.id), ginfo.modelName);
            
            XPortal.GridActions.InitIndividualActions(ginfo, settings, viewSettings);
            XPortal.GridInlineEditing.Init(ginfo, settings, modelPath);
            ginfo = self.GetGridInfo(ginfo.grid.kendoGrid(settings));
            XPortal.Store.AppStore.dispatch({
                type: XPortal.Redusers.ACTIONS.GRID_INITIALIZE,
                model: ginfo.modelName,
                modelValue: ginfo.kgrid,
                additionalModel: {
                    selector: "#" + ginfo.id,
                    modelPath,
                    Alias: ginfo.entityAlias,
                    NodeId: settings.pageData.nodeId,
                    modelName: ginfo.modelName,
                    AutofillFields: settings.pageData.AutofillFields
                }
            });
            if (settings.messages.savedetail) { //now dispatch only save messages 
                //add more if will be needed in store
                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ADD_MESSAGES, messages: settings.messages.savedetail, modelName: XPortal.Store.getGridModelName(ginfo.grid) });
            }
            XPortal.GridActions.InitActions(ginfo, settings);
            self.defaultViews[settings.pageData.nodeId] = JSON.stringify(ginfo.kgrid.getOptions());
            self.AdditionalBindings(ginfo.grid);
            if (!ginfo.grid.hasClass('entity-grid-calendar')) setTimeout(function () { self.ShowGrid(ginfo.grid); }, 200);
            else XPortal.GridCalendar.ButtonsPanel.init(ginfo.grid);
            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.GRID_INITIALIZED, model: ginfo.modelName });
            return ginfo.kgrid;
        },
        Init: function (igridEl, settingsObj, pageData, staticSource, disableResizing, relationFilter) {
            var result = { pageData };
            let ginfo = self.GetGridInfo($(igridEl));

            this.updateColumnsWidthSettings(igridEl, settingsObj);

            for (var f in settingsObj.dataSource.schema.model.fields) {
                if (Number(f[0]) > 0) {
                    settingsObj.dataSource.schema.model.fields[self.normalizeFieldPrefix + f] = settingsObj.dataSource.schema.model.fields[f];
                    settingsObj.dataSource.schema.model.fields[self.normalizeFieldPrefix + f].field = self.normalizeFieldPrefix + f;
                    settingsObj.dataSource.schema.model.fields[self.normalizeFieldPrefix + f].fieldOrg = f;
                    delete settingsObj.dataSource.schema.model.fields[f];
                    var col = _.find(settingsObj.columns, function (i) { return i.field == f; });
                    col.field = self.normalizeFieldPrefix + f;
                }
            }
            var dsrc =
            {
                pageData: pageData,
                dataSource: {
                    transport: {
                        read: async function (options) {
                            let dstransport = this;
                            if (isOrphanedTransport(ginfo, dstransport)) return;
                            if (result.dataSource.fields.length < 1)
                                return options.success([]);
                            ginfo = self.GetGridInfo(ginfo.grid, ginfo);
                            XPortal.Loader.show({ selector: ginfo.parent, showDelayTime: 500 });
                            XPortal.GridCalendar.InitBaseColumns(result.dataSource.fields, ginfo.grid);
                            XPortal.GridActions.OpenFilter(ginfo.grid);
                            if (staticSource != null && staticSource.length >= 0)
                                return options.success(XPortal.Grid.ConvertToKendoData({ Result: { Items: staticSource } }, options, result));
                            clearTimeout(ginfo.data.requestTimeout);
                            ginfo.data.requestTimeout = setTimeout(function () {
                                let searchRequest = getSearchRequest(options, ginfo, pageData, relationFilter);
                                ginfo.grid.trigger("grid.beforeRequest", [ginfo.grid, searchRequest]);
                                let requestId = ginfo.data.requestId = (ginfo.data.requestId || 1) + 1;
                                ((searchRequest.filter || {}).filters || []).every(x => delete x.Field);
                                const hdrs = getGridHeaders(ginfo, searchRequest.details && searchRequest.details.parentInfo);
                                jQuery.ajax({
                                    method: "POST", dataType: "json", cache: false, contentType: 'application/json; charset=utf-8', url: XPortal.Utils.EnsureInProfile(ginfo.grid.attr("data-url")),
                                    data: kendo.stringify({ model: searchRequest }),
                                    headers: hdrs,
                                    success: function (xdata) {
                                        if (self.GetGridInfo(ginfo.grid).kgrid == null) return console.log('there is no grid container anymore to load data there:', ginfo.modelName);
                                        if (isOrphanedTransport(ginfo, dstransport)) return console.log('grid data source was replaced> response dropped:', ginfo.modelName);
                                        xdata.requestId = requestId;
                                        if (requestId != ginfo.data.requestId) console.log('older grid request> blocked');
                                        if (XPortal.GridCalendar.GetGridCalendarOptions(ginfo.nodeId).isHideEmptyParent) {
                                            getGridCalendarInformationBy(xdata, ginfo).then(function (cxdata) {
                                                cxdata.requestId = xdata.requestId;
                                                successGetGridData(cxdata, searchRequest, ginfo, options, dstransport).then(function () {
                                                    successGetGridDataFinal(ginfo);
                                                });
                                            });
                                        } else successGetGridData(xdata, searchRequest, ginfo, options, dstransport).then(function () {
                                            successGetGridDataFinal(ginfo);
                                        });
                                    },
                                    error: function (jqXHR, textStatus, errorThrown) {
                                        XPortal.Grid.ProccessError(options, jqXHR, textStatus, errorThrown);
                                    }
                                });
                            }, self.requestDebounceMs);
                        }
                    },
                    requestStart: function (e) {
                        var dataSource = this;
                        if (XPortal.Store.ValidateGridModel(ginfo.modelName)) return;
                        e.preventDefault();
                        XPortal.GridActions.AlertUnsavedChanges({ isNewItem: false, isFormWasChanged: true }).then(function (mr) {
                            if (mr.result === "no") {
                                var model = XPortal.Store.GetModelByName(ginfo.modelName);
                                XPortal.Store.ClearItemToSave(model);
                                dataSource.read();
                            }
                        });
                    },
                    requestEnd: function (r) {
                        if (r.sender && r.sender._page == 1) r.sender.iRequestEnd = r;
                        setTimeout(function () { r.sender.iRequestEnd = null; }, 5000);
                        ginfo.grid.trigger("grid.requestEnd", r);
                    }
                },
                dataBound: function (e) {
                    if (!ginfo.kgrid) ginfo = XPortal.Grid.GetGridInfo(ginfo.grid);
                    ginfo.grid.trigger("grid.dataBound", [ginfo.grid, e]);
                    XPortal.Grid.SetGroupingFixedWidth(ginfo.grid, settingsObj.collapsed);
                    XPortal.Grid.RestoreDataFormating(ginfo.grid);
                    XPortal.Grid.SyncColMinWidth(ginfo.grid);
                    XPortal.DropdownBtns.gridButtons.init(ginfo.grid);
                    XPortal.GridActions.RestoreSelection(ginfo);
                    XPortal.TagsEditor.BindOnGridEvents(ginfo);
                    XPortal.SectionDisplayRules.CalculateFormattingRules(ginfo, e);
                    XPortal.ToolTips.Init($(ginfo.grid));
                    XPortal.Loader.hide({ selector: ginfo.parent });
                },
                filter: function (e) {
                    if (!XPortal.Store.ValidateGridModel(ginfo.modelName)) e.preventDefault();
                },
                group: function (e) {
                    if (!XPortal.Store.ValidateGridModel(ginfo.modelName)) e.preventDefault();
                    e.groups.forEach(function (gr) {
                        if (!gr.compare) {
                            gr.compare = function (a, b) {
                                if (a.value === b.value)
                                    return 0;
                                else if (a.value === null || a.value === "")
                                    return 1;
                                else if (b.value === null || b.value === "")
                                    return -1;
                                else
                                    return 1;

                            };
                        }
                    });
                },
                sort: function (e) {
                    if (!XPortal.Store.ValidateGridModel(ginfo.modelName)) e.preventDefault();
                },
                page: function (e) {
                    if (!XPortal.Store.ValidateGridModel(ginfo.modelName)) e.preventDefault();
                },
                change: function (e) {
                    ginfo.grid.trigger("grid.change", e);
                },
                edit: function (e) {
                    if (e.container.hasClass('last-cell-editor')) return;
                    setTimeout(() => {
                        const inputs = e.container.find("input.form-control");
                        const kendoEditor = _.find(inputs.map((_, x) => $(x).data("kendoComboBox") || $(x).data("kendoMultiSelect") || $(x).data("kendoDatePicker") || $(x).data("kendoDateTimePicker")), x => x != null);
                        if (kendoEditor) return kendoEditor.open();
                    }, 50);
                },
            };

            result = jQuery.extend(true, result, XPortal.Grid.settings, settingsObj, dsrc);
            if (result.filterable === true) result.filterable = XPortal.Grid.settings.filterable;
            result.pageable.pageSizes = result.pageable.pageSizes && result.pageable.pageSizes.length > 0 ? result.pageable.pageSizes : _.union(XPortal.Grid.settings.pageable.pageSizes, [settingsObj.dataSource.pageSize]);
            result.inlineEditorsLoadUrl = ginfo.grid.attr("data-editorsload-url");
            result.addinlineUrl = ginfo.grid.attr("data-addinline-url");
            Object.keys(result.dataSource.schema.model.fields).forEach(function (field) {
                if (field.validation)
                    field.validation.validate = function (e) {
                        console.log("validation");
                    };
            });
            result.columns.forEach(function (column) {
                if (result.dataSource.schema.model.fields.hasOwnProperty(column.field)) {
                    var field = result.dataSource.schema.model.fields[column.field];
                    XPortal.Grid.AdjustSchemaModelInfo(ginfo.grid, field, column, result.dataSource.schema.model.siteformats, pageData);
                }
            });

            if ('ontouchstart' in document.documentElement) {
                result.mobile = window.matchMedia("(max-width: 767px)").matches ? 'phone' : 'tablet';
                result.scrollable = true;
            }

            //fix of locked table height
            result.columnMenuInit = function (e) {
                var grid = this;
                var kendoMenuData = e.container.find(kendo.roleSelector("menu")).data("kendoMenu");
                if (typeof kendoMenuData === typeof undefined) {
                    return;
                }

                kendoMenuData.bind("select", function (e) {
                    if ($(e.item).is(".k-lock, .k-unlock")) {
                        XPortal.Grid.FixLockedHeight(grid);
                    }
                });
            };

            result.columnResize = function (e) {
                XPortal.Grid.FixLockedHeight(this);
            };

            result.columnLock = function (e) {
                XPortal.Grid.FixLockedHeight(this);
            };

            result.columnUnlock = function (e) {
                XPortal.Grid.FixLockedHeight(this);
            };

            result.columnReorder = function (e) {
                XPortal.Grid.FixLockedHeight(this);
                setTimeout(function () {
                    XPortal.Grid.SyncColMinWidth(ginfo.grid);
                }, 0);
            };


            if (!('ontouchstart' in document.documentElement)) {
                XPortal.Grid.BindEvents(ginfo.grid);
            }



            $(window).on('resize orientationchange', function () {
                updateGridSize();
            });

            $(document).on('clientWidthChanged', function (e) {
                updateGridSize();
            });

            if (result.columns.some(column => column.aggrigationsInfo && column.aggrigationsInfo.length > 0)) {
                ginfo.grid.on("grid.onsearch", (e, searchRequest) => XPortal.Grid.Aggregation.CalculateAggregations($(e.target).data("kendoGrid"), searchRequest));
            }

            return result;
        },
        PreInit: function (selector) {
            var container = $(selector ? selector : "body");
            container.find(".entity-grid").each(function (i, element) {
                try {
                    $element = $(element);
                    if (XPortal.Utils.isElementInsideVisibleTabsOrDD($element)) {
                        self.initFor($(element), XPortal.Store.getGridModelName($element.attr("id")));                        
                    }
                } catch (e) {
                    console.log('can\'t initialize grid, error', { grid: $(element), i, error: e });
                }
            });
        },
        initFor: function (gel, modelName) {
            if (gel.hasClass('inited')) return;
            gel.addClass('inited');
            var ginfo = self.GetGridInfo($(gel));
            var grClms = XPortal.Utils.readJsonStr(gel.attr("data-stgs-mn"));
            var grdSts = XPortal.Grid.ExtendSettings(grClms, XPortal.Utils.readJsonStr(gel.attr("data-stgs-ex"), {}), null, ginfo);
            var grdMnd = XPortal.Utils.readJsonStr(gel.attr("data-stgs-pg"));
            gel.attr("data-stgs-mn", "");
            gel.attr("data-stgs-ex", "");
            gel.attr("data-stgs-pg", "");
            XPortal.Main.customThemes('.quick-search-wrp');
            XPortal.GridCalendar.SetCalendarOptions(grClms, grdMnd.nodeId);
            var result = XPortal.Grid.Init(gel, grdSts, grdMnd);
            XPortal.GridSizing.adjustRelatedSectionsInit(ginfo.grid); 
            XPortal.GridSizing.adjustRelatedSections(ginfo.grid, ginfo);
            if (grClms.extendedOptions.hideCustomViews)
                XPortal.Grid.InitSelectableGrid(ginfo.grid, result);
            else//load custom view ordefault
                XPortal.GridSettings.Init({ selectableGridOptions: result, id: grdMnd.nodeId, DefViewTitle: grClms.messages.defaultViewTitle, remove: "#delgr-sett-frm" + grdMnd.nodeId, add: "#savegridsettingsbox" + grdMnd.nodeId, page: grdMnd }, "#dropdown-" + grdMnd.nodeId, "#sidebargv-items" + grdMnd.nodeId);

            ginfo.parent.on("click", ".hide-parent-button", function (e) {
                var hideParent = $(this).prop('checked');
                XPortal.GridCalendar.ChangeHideEmptyParent(gel, hideParent);
            });
        },
        ConvertLookupData: function (lookupData, sdata, settingsObj) {
            var keys = lookupData == null ? [] : Object.keys(lookupData);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var fieldLookups = lookupData[key];
                var fieldNames = Object.keys(fieldLookups);
                var dataItem = sdata.find(obj => {
                    return obj.UniqueId === key;
                });
                for (var j = 0; j < fieldNames.length; j++) {
                    let fieldName = fieldNames[j];
                    var values = dataItem[fieldName];
                    if (values && !Array.isArray(values)) {
                        if (values["split"])
                            values = values.split("_#_");
                    }
                    if (!Array.isArray(values)) values = [values];

                    var template = dataItem['displayTemplate'] = (settingsObj.columns.find(obj => {
                        return obj.field === fieldName;
                    }) || {}).displayTemplate;
                    dataItem[fieldName + "___Value___"] = (template && template.length)
                        ? "<span>" + (fieldLookups[fieldName] || []).join() + "</span>"
                        : "<span>" + values.join() + "</span>";
                }
            }
            return sdata;
        },
        transformTemplateToKendo: function (tmplate) {
            var ireplaced = tmplate || "";
            do {
                tmplate = ireplaced;
                ireplaced = ireplaced.replace(/\[\[([^\]\]]*)\]\]/, function (a, b) {
                    return '#=' + b + '#';
                });
                ireplaced = ireplaced.replace(/##\s*([^##]*)\s*##/, function (a, b) {
                    return '#=' + b + '#';
                });
            } while (tmplate != ireplaced);
            return ireplaced;
        },
        GetDefaultTitleTemplate: function (lookupField) {
            return "<span>#:data." + lookupField.toLowerCase() + "#</span>";
        },
        GetGridTitle: function (model, orAlias) {
            return $(model.model?.selector).data("file-title") || (orAlias ? model?.Alias || model?.model?.Alias || "" : "");
        },
        GetColumnTitle: function (model, columnName) {
            const col = model.GridModel.columns.find(c => c.field?.toLowerCase() == columnName.toLowerCase());
            return col ? col.title || columnName : columnName;
        },
        GetGridValidationError: function (model, showModelTitle) {
            const messages = (model.itemsToSave || []).reduce((all, item) =>
                all.concat((item.entity.validationResults || {}).summaryDetails || []), []);
            if (!messages.length) return "";
            return `${showModelTitle ? (self.GetGridTitle(model, true) + ': ') : ""}${messages.map(msg => `${self.GetColumnTitle(model, msg.field)} - ${msg.error}`).join("<br>")}`;
        },
        GetLookupData: function (sdata, gridEl, settingsObj, pageData, setValues) {
            let lookupFields = [];
            let gridDataId = $(gridEl).attr("data-id");
            let parentInfo = XPortal.Grid.dictionaryParent[gridDataId] || "";
            parentInfo = decodeURIComponent(parentInfo.replace(/\+/g, ' '));
            let nodisplay = [];
            for (var i = 0; i < settingsObj.columns.length; i++) {
                var item = settingsObj.columns[i];
                if (item.isLookupField) {
                    const editorInfo = !settingsObj.editors ? null : settingsObj.editors.find(e => e.field == item.field && (e.editor == "_default" || e.editor == "hidden"));
                    if (!editorInfo) {
                        if (item.displayTemplate) {
                            let values = !(setValues) ? null : sdata.map(function (xrecord) { return { id: XPortal.Template.GetObjPropValueByName(xrecord, "uniqueid"), value: XPortal.Template.GetObjPropValueByName(xrecord, item.field) }; }).filter(function (el) { return el.value != null && el.value != ""; });
                            lookupFields.push({ Field: item.field, LookupAlias: item.lookupAlias, LookupField: item.lookupField, Values: values });
                        } else {
                            var f = nodisplay.find(x => item.field);
                            if (!f) nodisplay.push(item.field);
                        }
                    }
                }
            }
            if (nodisplay.length > 0 && console) {
                if (!self.nodisplayWarn) self.nodisplayWarn = [];
                nodisplay = nodisplay.filter(fi => !(self.nodisplayWarn.find(ndfi => ndfi == fi)));
                nodisplay.forEach(fi => self.nodisplayWarn.push(fi));
                if (nodisplay.length > 0) console.log("there is no display template for lookup fields:" + nodisplay.join(", "), nodisplay);
            }
            var uniqueIds = jQuery.map(sdata, function (item) {
                return item.UniqueId;
            });
            if (!lookupFields || lookupFields.length == 0) return $.Deferred().resolve(null);
            var lookupInfo = { LookupFields: lookupFields, UniqueIds: uniqueIds, NodeId: pageData.nodeId, EntityAlias: gridEl.attr("entityalias"), parentInfo: parentInfo };
            return XPortal.Utils.APIPost("/umbraco/Surface/GridView/GetLookupData", { model: lookupInfo }, { contentType: 'application/json' });
        },
        AdditionalBindings: function (grid) {
            XPortal.Grid.SetActionsLink(grid);
            XPortal.Grid.ToolTipInit(grid);
        },
        FixLockedHeight: function (grid) {
            setTimeout(function () {
                var $gridWrapper = grid.table.closest('.k-grid');
                var $locked = $gridWrapper.find('.k-grid-content-locked');
                if (!$locked.length) {
                    return;
                }

                $locked.css({ 'height': $gridWrapper.find('.k-grid-content').height() });
            }, 30);
        },
        ToolTipInit: function (grid) {
            grid.closest(".grid-parent").kendoTooltip({
                show: function (e) {
                    this.popup.element.addClass('grid-tooltip');
                },
                filter: ".k-grid table tbody td[role='gridcell']:not([data-ctype='boolean']):not([data-cfield='alerts']):not('.k-edit-cell'):not('.service'), td .tags-format-container, th[role='columnheader'], .original-title",
                position: "top",
                width: 'auto',
                showAfter: 1500,
                content: function (e) {
                    const $target = $(e.target);

                    if ($target.hasClass('original-title')) {
                        return $target.text().trim();
                    }

                    let $isTags = $target.find(".tags-format-container").length > 0 || $target.hasClass("tags-format-container");
                    const hasFRTooltip = $target.find("a.tooltip.fr-tooltip").length;
                    
                    if ($isTags) {
                        return XPortal.TagsEditor.GetTagsTooltip($target);
                    } else if (hasFRTooltip) {
                        return;
                    } else {
                        var serviceCell = $target.closest("td.service[role='gridcell']");
                        if (serviceCell && serviceCell.length > 0) {
                            var row = $target.closest("tr[role='row']")[0];
                            var uid = $(row).attr("data-uid");
                            var dataItem = grid.data("kendoGrid").dataSource.getByUid(uid);
                            return dataItem && dataItem.validationResults && dataItem.validationResults.summary && dataItem.validationResults.summary.length > 0
                                ? dataItem.validationResults.summary
                                : "";
                        }

                        let content = '';
                        if ($target.attr('role') == 'columnheader') {
                            const $cell = $target.find('.k-link');
                            content = $cell.length && $.trim($cell.text()).length ? $cell.text() : '';
                        } else {
                            const $cell = $target.find('.tdcell');
                            content = $cell.length && $.trim($cell.text()).length ? $target.html() : '';
                        }

                        return content;
                    }
                }
            });
        },
        PrepareDownloadCellsMark: function (element, nodeId, columns, items) {
            var downloadCols = columns.filter(col => (col.format && (col.format.indexOf('"download"') > -1 || col.format.indexOf('DownloadAllAttachments') > -1))).map(col => col.field);
            var itemsToGetLog = items.filter(function (item) {
                return item.hasOwnProperty("Fields") && item.Fields.filter(i => downloadCols.includes(i.Name.toLowerCase())).length > 0;
            });

            if (itemsToGetLog.length > 0) {
                var requestParameters = {
                    Request: {
                        Items: itemsToGetLog.map(i => i.UniqueId),
                        NodeId: nodeId
                    },
                    Element: element,
                    MarkPattern: 'a.download'
                };
                return requestParameters;
            }
        },
        ResizeGrid: function (gridEl) {
            try {
                if (!XPortal.GridSizing.isGridVisible(gridEl)) return;

                const gridInfo = self.GetGridInfo(gridEl);
                const defaultMinHeight = XPortal.GridSizing.getDefaultMinHeight(gridEl);
                const calculatedGridHeight = XPortal.GridSizing.calculateGridHeight(gridEl, gridInfo, defaultMinHeight);
                gridEl.data('base-grid-height', calculatedGridHeight).data('row-fill', 0);

                XPortal.GridSizing.setGridHeight(gridEl, calculatedGridHeight);
                XPortal.GridSizing.adjustListViewHeight(gridEl, calculatedGridHeight);
                XPortal.GridSizing.adjustParentHeight(gridEl, gridInfo, calculatedGridHeight);
                XPortal.GridSizing.adjustSectionContentHeight(gridEl);
                XPortal.GridSizing.resizeKGrid(gridInfo);
                XPortal.GridSizing.adjustGridHeaderHeight(gridEl);
                XPortal.GridSizing.adjustRelatedSections(gridEl, gridInfo);
                XPortal.GridSizing.fillRowHeight(gridEl);
                XPortal.GridSizing.observeRowSiblings(gridEl);
                XPortal.GridSizing.updateDetailScroll(gridEl.closest('.detailblock-viewcontainer'));
                XPortal.GridSizing.adjustExpandCollapsePosition(gridEl, gridInfo);
                XPortal.GridSizing.adjustGridHeaderActions(gridInfo, gridEl);
            } catch (error) {
                console.warn('resize grid issue:', error);
            }
        },

        SetGroupingFixedWidth: function (gridEl, collappsed) {
            var data = gridEl.data("kendoGrid");
            if (!data || !data._group || !data.lockedTable || data.lockedTable.length < 1)
                return;

            var fixedRows = data.lockedTable[0].rows;
            var contentRows = data.table[0].rows;

            for (var i = 0; i < fixedRows.length; i++) {
                var $this = $(fixedRows[i]);
                if ($this.hasClass('k-grouping-row')) {
                    var $clone = $this.find('.k-reset').clone();
                    $clone.find('.k-icon').remove();
                    $(contentRows[i].cells[0]).append($clone.html());
                }
            }
            if (collappsed) {
                XPortal.GridActions.ChangeCollapseState(gridEl, true);
            }
        },
        SyncColMinWidth: function (gridEl) {
            var data = gridEl.data("kendoGrid");
            if (!data) return;

            function syncTable($table) {
                if (!$table || !$table.length) return;
                $table.find("colgroup col").each(function (i) {
                    if (i === 0) return;
                    var w = this.style.width || $(this).css("width");
                    if (w) $(this).css("min-width", w);
                });
            }

            syncTable(data.table);
            syncTable(data.thead ? data.thead.closest("table") : null);
            syncTable(data.lockedTable);
            syncTable(data.lockedHeader ? data.lockedHeader.closest("table") : null);
        },
        _clickedBool: null,
        BindEvents: function (grid) {

            var tooltip = grid.kendoTooltip({
                show: function (e) {
                    this.popup.element.addClass('grid-tooltip');
                    this.popup.element.addClass('calendar-tooltip');
                },
                _showOn: function (e) {
                    e.preventDefault();
                },
                autoHide: false,
                filter: ".scheduler-cell:not(:has(.k-event-block.group))",
                content: kendo.template($("#tooltip-template").html()),
                position: "top",
                offset: 0
            }).data("kendoTooltip");

            grid.on("mouseenter", "table tbody tr", hightligtRow);
            grid.on("mouseleave", "table tbody tr", unhightligtRow);
            grid.on("click", "table tbody tr td span label", function (e) {
                if (grid.getKendoGrid().options.editable && $(this).parents(".k-state-focused").length === 1)
                    XPortal.Grid._clickedBool = { rowUid: $(this).parents("tr").attr("data-uid"), colUid: $(this).parents("td").attr("aria-describedby") };
            });
            grid.on("click", "table tbody tr td.scheduler-cell", function (e) {
                if ($(e.target).hasClass('btn')) {
                    return;
                }

                var $this = $(this);
                var isActive = $this.hasClass('active');
                $('.scheduler-cell').removeClass('active');
                if (!isActive) {
                    $this.addClass('active');
                }
            });
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.scheduler-cell').length) {
                    $('.scheduler-cell').removeClass('active');
                }
                var element = null;
                element = $(e.target).is(".k-event-block") ? $(e.target) : $(e.target).closest(".k-event-block");
                var cell = $(element).is(".scheduler-cell") ? $(element) : $(element).closest(".scheduler-cell");
                if (cell.length && !cell.find(".k-event-block.group").length) {
                    tooltip.show(cell);
                }

                var gridElement = $(e.target).is(".btn-grid") ? $(e.target) : $(e.target).closest(".btn-grid");
                if (gridElement.length !== 0) {
                    cell = $(gridElement).is(".scheduler-cell") ? $(gridElement) : $(gridElement).closest(".scheduler-cell");
                    if (cell.length) window.location.href = XPortal.GridCalendar.NavigateToGrid(cell, grid);
                }
            });

            self.updateResizeColStyles(grid);
        },
        updateResizeColStyles: function (grid) {
            let resizingState = false;
            let activeTh = null;

            grid.on("mousedown mouseup mouseleave mouseenter", ".k-resize-handle", function (e) {
                const handleLeft = $(this).offset().left;
                const $colHeaders = grid.find("thead th[role='columnheader']");
                let closestTh = null;
                let minDiff = Infinity;

                $colHeaders.each(function () {
                    const $th = $(this);
                    const thRight = $th.offset().left + $th.outerWidth();
                    const diff = Math.abs(handleLeft - thRight);
                    if (diff < minDiff) {
                        minDiff = diff;
                        closestTh = $th;
                    }
                });

                if (!closestTh) return;

                switch (e.type) {
                    case "mousedown":
                        closestTh.addClass("resizing");
                        resizingState = true;
                        activeTh = closestTh;
                        break;

                    case "mouseup":
                        if (activeTh) {
                            activeTh.removeClass("resizing");
                            activeTh = null;
                        }
                        resizingState = false;
                        break;

                    case "mouseenter":
                        if (!resizingState) {
                            closestTh.addClass("resizing");
                            activeTh = closestTh;
                        }
                        break;

                    case "mouseleave":
                        if (!resizingState && activeTh) {
                            activeTh.removeClass("resizing");
                            activeTh = null;
                        }
                        break;
                }
            });

            grid.on("mouseleave mouseenter", "thead th[role='columnheader']", function (e) {
                const $this = $(this);
                if (!resizingState) {
                    if (e.type === "mouseenter") {
                        $this.addClass('resizing-hover');
                    } else if (e.type === "mouseleave") {
                        $this.removeClass("resizing-hover");
                    }
                }
            });

            grid.on("mouseup", function (e) {
                const $colHeaders = grid.find("thead th[role='columnheader']");
                $colHeaders.removeClass("resizing");
                resizingState = false;
            });
        },
        SetQuickSearch: function (grid, searchContainer) {
            if (grid.data("kendoGrid") == null)
                return false;
            var ds = grid.data("kendoGrid").dataSource;
            let groupFilter = {
                field: "___group___",
                operator: "eq",
                value: "___group___",
                logic: "And",
                isForQSearch: true
            };
            var newfilter = { field: "__keywords", operator: "eq", value: XPortal.Grid.GetKeywords($(searchContainer)), isForQSearch: true };
            var cfilters = [];
            var combinefilters = grid.attr("data-combinefilters") == "1";
            if (combinefilters) {
                var currentfilters = ds.filter() ? ds.filter().filters : [];
                cfilters = currentfilters.filter(function (x) { return !(x["isForQSearch"]); });
            }
            let resultFilters = [groupFilter, newfilter, ...cfilters];
            self.SetFilters(resultFilters, ds, true);
        },
        SetActionsLink: function (grid) {
            var parentGrid = grid.closest(".grid-parent");
            var kgridData = grid.data("kendoGrid");
            var nodeId = kgridData.options.pageData.nodeId;
            if (parentGrid) {
                grid.closest(".grid-parent").find(".btn-quick-search").on('click', function (e) {
                    e.preventDefault();
                    XPortal.Grid.ToggleQuickSearchMobile(this);
                    XPortal.Grid.SetQuickSearch(grid, this);
                });
                let quickSearchSelector = "#quick-search-" + nodeId;
                grid.closest(".grid-parent").find(quickSearchSelector).on('keydown', function (e) {
                    if (e.which == 13) {
                        XPortal.Grid.SetQuickSearch(grid, this);
                        return false;
                    }
                });
                grid.closest(".grid-parent").find(quickSearchSelector).on('input', function (e) {
                    if (!this.value) {
                        XPortal.Grid.SetQuickSearch(grid, this);
                    }
                });
            }
        },
        SectionQuickSearch: function () {
            let relatedGridsIdis = $('[data-related-grids]').data("relatedGrids");
            if (relatedGridsIdis.length > 0)
                HideRelatedGridsQuickSearches(relatedGridsIdis);
            else
                HideContainerGridsQuickSearches();
        },
        ToggleQuickSearchMobile: function (btn) {
            const isMobile = window.innerWidth < 576;

            if (!isMobile) {
                return;
            }

            const $control = $(btn).closest('.quick-search-control');
            const $wrp = $control.closest('.quick-search-wrp_grid');
            const $header = $wrp.closest('.grid-action-header');
            const $actionsCol = $header.find('.grid-actions-col');
            const $headerCol = $header.find('.grid-header-title');

            $control.toggleClass('search-wrp-mobile');

            if ($control.hasClass('search-wrp-mobile')) {
                $actionsCol.css('opacity', '0');
                $headerCol.css('opacity', '0');

                const headerWidth = $header.outerWidth();
                const leftDiff = $wrp.offset().left - $header.offset().left;

                $wrp.css({
                    'width': headerWidth + 'px',
                    'margin-left': '-' + leftDiff + 'px',
                    'overflow': 'hidden'
                });
            } else {
                $actionsCol.css('opacity', '');
                $headerCol.css('opacity', '');

                $wrp.css({
                    'width': '',
                    'margin-left': ''
                });
            }
        },
        TriggerChildQuickSeraches: function (input, parentSectionId, e) {
            if (e.which == 13 || e.which == 1) {
                //let relatedGridsIdis = $('[data-related-grids]').data("relatedGrids");
                let relatedGridsIdis = [];
                $('[data-parent-sectionid]').each(function () {
                    if ($(this).data("parent-sectionid") == parentSectionId)
                        relatedGridsIdis = $(this).data("related-grids");
                })
                //1. In case when relatedGridsIdis contains picked nodes - then only defined nodes/grids should be belongs to quick search
                if (relatedGridsIdis.length > 0) {
                    SearchByRelatedGrids(relatedGridsIdis, input);
                }
                // 2. otherwise picker should relates to all grid nodes in current container
                else {
                    SearchByContainerGrids(parentSectionId, input);
                }
            }
        },
        HideSubQuickSearches: function (parentSectionId) {
            $("#" + parentSectionId).find(".grid-action-header .quick-search-wrp").hide();
        },
        HideSectionQuickSearch: function (parentSectionId) {
            $("#" + parentSectionId).find(".section-quick-search").hide();
        },
        SetFilter: function (newfilter, ds, resetPrevFilter) {
            var newFilter = patchFilter(newfilter, ds.options.schema.model);
            var currentfilters = ds.filter() ? ds.filter().filters : [];
            if (resetPrevFilter) {
                currentfilters = currentfilters.filter(f => f.field !== "__keywords");
            }
            if (currentfilters.indexOf(newfilter) < 0) {
                currentfilters.push(newFilter);
            }
            ds.filter(currentfilters, ds.options);
        },
        SetFilters: function (newFilters, ds, resetPrevFilter) {
            var currentfilters = ds.filter() ? ds.filter().filters : [];
            if (resetPrevFilter) currentfilters = [];
            for (var i = 0; i < newFilters.length; i++) {
                let newFilter = newFilters[i];
                newFilter = patchFilter(newFilter, ds.options.schema.model);

                if (currentfilters.indexOf(newFilter) < 0) {
                    currentfilters.push(newFilter);
                }
            }
            ds.filter(currentfilters, ds.options);
        },
        BindCustomElements: function (grid, settings) {
            var kgridData = grid.data("kendoGrid") || {};
            if (kgridData.resizable) {
                kgridData.resizable.unbind("start", preventServiseColumnResizing);
                kgridData.resizable.bind("start", preventServiseColumnResizing);
            }
        },
        GetKeywords: function (element) {
            var qsContainer = $(element).closest(".quick-search-container");
            var qs = qsContainer.find(".quick-search");
            var sectionQs = qsContainer.find(".section-quick-search");
            var quickSearch = qs.length ? qs : (sectionQs.length ? sectionQs : []);
            var keywordsString = quickSearch.length > 0 ? quickSearch.val() : "";
            return keywordsString;
        },
        ExtendSettings: function (target, extSettings, additionalSettings, ginfo) {
            if (extSettings == null) return target;
            if (extSettings.columns != null && target.columns != null) {
                _.each(extSettings.columns, function (col) {
                    var ccol = _.find(target.columns, function (tcol) { return tcol.field == col.field; });
                    if (ccol != null) $.extend(ccol, col);
                });
                delete extSettings["columns"];
            }
            //merge grid sort settings with script sort settings
            self.ExtendSortSettings(target, extSettings);

            ColTagsNotEditable(target);

            $.extend(true, target, extSettings);
            if (additionalSettings) $.extend(true, target, additionalSettings);

            if (_.object(target.groupable) && !target.groupable.hasOwnProperty("enabled"))
                target.groupable.enabled = false;
            return target;
        },
        ExtendSortSettings: function (target, exSettings) {
            if (exSettings == null || target == null) return;
            for (let key in exSettings) {
                let stgItem = exSettings[key];
                if (key == 'sort') {
                    let targetSortFields = (target.dataSource == null && target.dataSource.sort == null) ? [] : target.dataSource.sort;
                    let srtFields = _.isArray() ? stgItem : [stgItem];
                    srtFields.forEach((v, vi) => {
                        const srtItem = v;
                        srtItem["field"] = (srtItem["field"] || "").toLowerCase();
                        if (targetSortFields.find(i => i.field.toLowerCase() == srtItem["field"]) == null)
                            targetSortFields.push(srtItem);
                    });
                }
                else if (_.isObject(stgItem) && !_.isArray(stgItem))
                    self.ExtendSortSettings(target, stgItem);
            }
            delete exSettings['sort'];
        },
        ExtendedFormat: function (nodeId, field, ...args) {
            var dsFormat = self.customFormats[nodeId] = self.customFormats[nodeId] || { fields: {} };
            var res = dsFormat[field];
            if (args.length > 0) dsFormat[field] = res = args[0];
            return res;
        },
        Aggregation: {
            GetFooterColumnTemplate: function (field, aggregationInfo, gridEl) {
                const fname = field.toLowerCase();
                aggregationInfo = gridEl ? self.GetGridInfo(gridEl).kgrid.columns.find(x => x.field.toLowerCase() === fname).aggrigationsInfo : aggregationInfo;
                var container = $("<div class='column-footer-aggregation' data-field='" + fname + "'></div>");
                aggregationInfo.forEach(function (agg) {
                    var aggNode = $("<div data-agg-type='" + agg.AggType + "'>" + XPortal.Template.ReplaceFormatString(agg.Template, agg.Value) + "</div>");
                    aggNode.appendTo(container);
                });
                return container[0].outerHTML;
            },

            CalculateAggregations: function (gridData, searchRequest) {
                const gridDataId = $(gridData.element).attr("data-id");
                const parentInfo = decodeURIComponent(XPortal.Grid.dictionaryParent[gridDataId]);
                searchRequest.parentInfo = parentInfo;

                var xdata = $(gridData.element).data("xgriddata");
                if (!xdata) $(gridData.element).data("xgriddata", xdata = {});
                xdata.lastAggregationSearchRequest = searchRequest;

                const postData = { searchModel: searchRequest };
                const rsstToken = new URLSearchParams(window.location.search).get("rsst");
                const dataAggregationUrl = gridData.element.attr("data-aggregations-url") + (rsstToken ? `?rsst=${encodeURIComponent(rsstToken)}` : "");

                XPortal.Utils.APIPost(dataAggregationUrl, postData)
                    .then(function (result) {
                        XPortal.Grid.Aggregation.UpdateFooterAggregations(gridData, result);
                    })
                    .fail(function () {
                        console.error("Unable to calculate grid aggregations!");
                    });
            },

            RecalculateForGridElement: function (gridSelector) {
                var gridEl = $("#" + gridSelector);
                var kgrid = gridEl.data("kendoGrid");
                if (!kgrid) return;
                if (!kgrid.columns.some(c => c.aggrigationsInfo && c.aggrigationsInfo.length > 0)) return;

                var xdata = gridEl.data("xgriddata");
                var lastRequest = xdata && xdata.lastAggregationSearchRequest;
                if (!lastRequest) return;

                XPortal.Grid.Aggregation.CalculateAggregations(kgrid, $.extend(true, {}, lastRequest));
            },

            UpdateFooterAggregations: function (gridData, result) {
                if (!result || result.length === 0) return;
                gridData.columns.forEach(function (c) {
                    if (!c.footerTemplate) { return; }
                    const cfield = c.field.toLowerCase();
                    var columnAggregationResult = result.find(r => r.Field.toLowerCase() === cfield);
                    if (!columnAggregationResult) { return; }

                    c.aggrigationsInfo = columnAggregationResult.Items;
                });
                if (typeof gridData._footer === "function") gridData._footer();
                else gridData.refresh();
            },
        },

        settings: {
            dataSource: {
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                schema: {
                    total: "total",
                    model: {
                        id: "UniqueId",
                        fields: {
                            UniqueId: { type: "string", convertor: "String", convertorformat: "", field: "UniqueId", isdetail: 0 }
                            //Selected: { Field:"Selected", isdetail: 0}
                        } /*fields*/
                    } /*model*/
                }
            },/*ds*/
            filterable: {
                // extend: true,
                operators: {
                    //filter menu for "string" type columns
                    string: {
                        eq: "Is equal to",
                        neq: "Is not equal to",
                        startswith: "Begins with",
                        contains: "Contains",
                        doesnotcontain: "Does not contain",
                        endswith: "Ends with",
                        isnull: "Blank",
                        isnotnull: "Is not Blank"
                    },
                    //filter menu for "number" type columns
                    number: {
                        eq: "Is equal to",
                        neq: "Is not equal to",
                        gte: "Greater or equal",
                        gt: "Greater than",
                        lte: "Less or equal",
                        lt: "Less than",
                        isnull: "Blank",
                        isnotnull: "Is not Blank"
                    },
                    //filter menu for "date" type columns
                    date: {
                        eq: "Is equal to",
                        neq: "Is not equal to",
                        gte: "Greater or equal",
                        gt: "Greater than",
                        lte: "Less or equal",
                        lt: "Less than",
                        isnull: "Blank",
                        isnotnull: "Is not Blank"
                    }

                }
            },
            pageable: {
                pageSizes: [20, 50, 100, "all"],
                messages: {
                    //display: "{0}-{1} of {2} items",
                    empty: "No data",
                    page: "",//"Enter page",
                    of: "",//"from- {0}",
                    itemsPerPage: "",// "data items per page",
                    first: "",
                    last: "",
                    next: "",
                    previous: "",
                    morePages: "..."
                }
                //messages: {
                //    allPages: 'All',
                //    display: '{0} - {1} of {2} items',
                //    empty: 'No items to display',
                //    page: 'Page',
                //    of: 'of {0}',
                //    itemsPerPage: 'items per page',
                //    first: 'Go to the first page',
                //    previous: 'Go to the previous page',
                //    next: 'Go to the next page',
                //    last: 'Go to the last page',
                //    refresh: 'Refresh',
                //    morePages: 'More pages'
                //}
            },
            noRecords: true,
            excel: {
                allPages: true,
                fileName: "Grid.xlsx",
                filterable: true
            },
            pdf:
            {
                allPages: false,
                fileName: "" + "Grid.pdf",
                paperSize: "auto",
                landscape: true
            }
        },
        normalizeFieldPrefix: "xnorm_",
        GetGridInfoById: function (id) {
            return self.GetGridInfo(".entity-grid-" + id);
        },
        GetGridInfo: function (xselector, existingInfo) {
            if (!xselector) return null;
            var gridEl = $(xselector);
            var r ={
                id: gridEl.attr("id"),
                nodeId: gridEl.attr("data-id"),
                entityAlias: gridEl.attr("entityalias"),
                grid: gridEl,
                modelName: XPortal.Store.getGridModelName(gridEl),
                parent: gridEl.closest('.grid-parent'),
                kgrid: gridEl.data("kendoGrid"),
                data: gridEl.data("xgriddata")
            };
            if (!r.data) gridEl.data("xgriddata", r.data = {});
            if (existingInfo != null) {
                if (existingInfo.grid == r.grid)
                    r = updateGridInfo(existingInfo, r);
                else if (existingInfo.kgrid == null && existingInfo.klist == null)
                    r = updateGridInfo(existingInfo, r);
            }
            r.list = r.parent.find("#entity-list-" + r.nodeId);
            r.klist = r.list.data("kendoListView"),
                r.actionsHeader = r.parent.find('.grid-action-header');
            r.actionsHeader = r.actionsHeader.length > 1 ? $(r.actionsHeader[1]) : r.actionsHeader;

            return r;
        },
        GetModelParentInfo: function (gridModelName) {
            if (!gridModelName || gridModelName.trim() == '') return null;
            const pmname = XPortal.Store.GetParentModelName(gridModelName);
            if (!pmname || pmname.trim() == '') return null;
            const pminfo = XPortal.Store.GetModelByName(pmname);
            if (!pminfo || !pminfo.entity) return null;
            const uid = XPortal.Template.GetObjPropValueByName(pminfo.entity, "uniqueid");
            const nid = XPortal.Template.GetObjPropValueByName(pminfo.model, "nodeid");
            return nid + "#|#" + uid;
        },
        GetModelParentName: function (gridModelName) {
            if (!gridModelName || gridModelName.trim() == '') return null;
            return XPortal.Store.GetParentModelName(gridModelName);
        },
        GetModelParentModel: function (gridModelName) {
            if (!gridModelName || gridModelName.trim() == '') return null;
            const prntModelName = XPortal.Store.GetParentModelName(gridModelName);
            return XPortal.Store.GetModelByName(prntModelName);
        },
        GetGridOptionButton: function (gridInfo, el, actinName, actionuid) {
            actinName = actinName || el.attr("data-action");
            var result = null;
            if ($.contains(gridInfo.actionsHeader.get(0), el.get(0))) return el;

            // content view action carries its own unique id and keeps its full markup (config +
            // popups, ComplexDelete/Modify) resolve to it first, so matching only by
            // data-action would pick the wrong element
            actionuid = actionuid || el.attr("data-action-uid");
            if (actionuid) {
                var srcBtn = gridInfo.parent.find(".entity-cv-actions-source > .action-source-item[data-uniqueid='" + actionuid + "'] .action").first();
                if (srcBtn.length) return srcBtn;
            }

            result = gridInfo.actionsHeader.find(".action").filter(function (ix, x) {
                return $(x).attr("data-action") == actinName;
            });
            if (result.length === 0) return el;
            if (result.length === 1) return result;
            result = result.filter(function (ix, x) {
                return $(x).closest("li").attr("data-uniqueid") == actionuid;
            });
            return result.length > 0 ? $(result[0]) : el;
        },
        GetGridDataRowItem: function (gridInfo, rowInternalDomElement, gridEl) {
            gridInfo = gridEl ? self.GetGridInfo(gridEl, gridInfo) : gridInfo;
            var currentObj = gridInfo.kgrid.dataItem(rowInternalDomElement.closest("tr"));
            if (currentObj) return currentObj;
            var cvitem = rowInternalDomElement.closest(".entity-cvitem");
            var uid = cvitem.attr("data-u-uid");
            currentObj = !uid ? null : gridInfo.klist.dataSource.data().find(x => XPortal.Template.GetObjPropValueByName(x, "uniqueid") === uid);
            return currentObj;
        },
        GetGridDataRow: function (gridInfo, rowInternalDomElement, gridEl) {
            gridInfo = gridEl ? self.GetGridInfo(gridEl, gridInfo) : gridInfo;
            return getGridDataRow(gridInfo, rowInternalDomElement) || getGridDataRowByListDataRow(gridInfo, rowInternalDomElement);
        },
        GetGridRowsByUniqueId: function (grid, iUniqueId, lockedAndUnlocked, selectedids) {
            return getGridRowsByUniqueId(grid, iUniqueId, lockedAndUnlocked, selectedids);
        },
        GetGridRowsByUid: function (grid, rowid, lockedAndUnlocked, selectedids) {
            return getGridRowsByUid(grid, rowid, lockedAndUnlocked, selectedids);
        },
        GetListRowsByUniqueId: function (list, iUniqueId, lstItemSelectr) {
            return getListRowsByUniqueId(list, iUniqueId, lstItemSelectr);
        },
        GetRowAction: function (gridInfo, action, cell) {
            var toolBarButton = cell.closest("tr").find(".service .dropdown-menu .action[data-action='" + action + "']")
            return toolBarButton;
        },
        GetHeadAction: function (gridInfo, action) {
            var toolHBarButton = gridInfo.parent.find(".grid-action-header").find(".action[data-action='" + action + "']");
            return toolHBarButton;
        },
        ContentViewVisible: function (data, o) {
            if (!data || !o || !o.f) return true;
            const res = XPortal.Template.ProcessFormula(o.f, data);
            try {
                const f = new Function('data', ' return ' + res + ';');
                const fres = f.apply(data, data);
                if (self.showDebugInfo) console.info("l.f.v: " + o.n + ", " + fres, { o, res, d: JSON.stringify({ data }) });
                if (fres) return true;
                return false;
            } catch (e) {
                console.warn("can't cal visiblity for list tile, field:" + o.n, { e, o, res });
            }
            return true;
        },
        ContentViewField: function (data, fsttgs, nodeid) {
            const gridInfo = self.GetGridInfoById(nodeid);
            const fval = XPortal.Template.GetObjPropValueByName;
            let inFormat;
            let fieldData = fval(data, fsttgs.field);
            if (data.fields && fieldData && fieldData.convertorformat == "n2") {
                inFormat = "{0:" + fieldData.convertorformat + "}";
            }
            if (!fsttgs || !fsttgs.formatExtended) {
                let v = getGridViewFieldValue(gridInfo, data, fsttgs);
                return v ? v : '';
            }

            const funcToR = new Function("data", "type", "field", "inFormat", "nodeid", "TemplateName", "fsttgs", 'return ' + fsttgs.formatExtended.Method + "(data, type, field, inFormat, nodeid, TemplateName, fsttgs);");
            const v = funcToR.call(this, data, fsttgs.type, fsttgs.field, inFormat, nodeid, fsttgs.formatExtended.TemplateName, fsttgs);
            return v ? v : '';
        },
        ContentViewImageField: function (data, fsttgs, nodeid) {
            if (data.IsCreating) return '';
            var graphExts = ['gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg'];
            var fileExt = data.fileextension ? data.fileextension.toLowerCase() : null;
            var isFileGraphic = fileExt ? graphExts.includes(fileExt) : true;

            var fval = XPortal.Template.GetObjPropValueByName;
            var dataUid = fval(data, "UniqueId");
            var v;

            if (isFileGraphic) {
                v = fval(data, fsttgs.field)
                v = v && v.indexOf('_#_') ? v.split('_#_') : v;
            };
            if (fsttgs.formatString)
                return getGridViewFieldValue(self.GetGridInfoById(nodeid), data, fsttgs);
            var sourceFileType = !isFileGraphic && data.fileextension;
            const defaultImgPath = this.isDarkTheme ? "/content/images/empty-content-view-item_tr_dark.png" : "/content/images/empty-content-view-item_tr.png";
            var ext = data.fileextension.replace('.', '');
            const availableIcons = ['svg', 'csv', 'doc', 'pdf', 'docx', 'xlsx', 'xls', 'ppt', 'txt'];
            fsttgs.noImageUrl = sourceFileType && availableIcons.includes(ext) ? `/content/images/icons/file_types/${ext}.png` : (fsttgs.noImageUrl ? fsttgs.noImageUrl : defaultImgPath);

            var iurl = !v ? fsttgs.noImageUrl : encodeURIComponent(typeof v === 'object' ? v[0] : v);
            var ialias = fval(data, "alias");
            ialias = ialias ? ialias : fval(data, "entityalias");
            var purl = !v ? iurl : `/umbraco/Surface/Detail/ImageAltr?i=${dataUid}&a=${ialias}&src=&cnfr=1&file=${iurl}&f=${fsttgs.field || "Image"}&altr=${fsttgs.noImageUrl}`;

            var r = $("<img/>");
            r.attr("src", purl);
            r.attr("data-alt-src", fsttgs.noImageUrl);
            r.attr("alt", fsttgs.title);
            r.attr("data-is-img", isFileGraphic);

            r.attr("data-dwl-src", "/umbraco/Surface/Detail/DownloadAllAttachments?id=" + dataUid + "&KeyField=" + fsttgs.field + "&NodeId=" + nodeid + "&pinfo=");
            var addClasses = sourceFileType ? " file-type-icon " : "";

            if (fsttgs.classes.length > 0)
                addClasses = fsttgs.classes + " " + addClasses;
            r.attr("class", addClasses.trim());

            return $("<div/>").append(r).html();
        },
        ContentViewService: function (data, nodeid, gridElId) {
            var ginfo = self.GetGridInfo($("#" + gridElId));
            var goptions = ginfo.kgrid.options.columns.find(x => x.field == "selectable");
            var r = goptions ? goptions.template : '<!-- -->';
            return r;
        },
        DataUniqueId: function (data, nodeid) {
            return XPortal.Template.GetObjPropValueByName(data, "UniqueId");
        },
        RestoreDataFormating: function (grid) {
            let ginfo = self.GetGridInfo(grid);
            if (!ginfo || !ginfo.kgrid) return;
            let gridPageItems = ginfo.kgrid.dataSource.view().slice();
            let dataItems = [];
            while (gridPageItems.length > 0) {
                var gridItem = gridPageItems[0];
                if (gridItem.items)
                    gridItem.items.forEach(function (i) {
                        gridPageItems.push(i);
                    });
                else dataItems.push(gridItem);
                gridPageItems.splice(0, 1);
            }
            for (var indx = 0; indx < dataItems.length; indx++) {
                var dataItem = dataItems[indx];
                if (dataItem.validationResults) {
                    var row = ginfo.grid.find(".k-grid-content tr[data-uid='" + dataItem.uid + "']");
                    var cells = row.find("td");
                    cells.each(function (cellIndex, cell) {
                        var fieldName = $(cell).attr("data-cfield");
                        $(cell).toggleClass("not-valid-cell", dataItem.validationResults[fieldName] === false);
                    });
                }
            }
        },
        ExecuteUpdateCalcFieldsData: function (uniqueIds, nodeId, otherData, headers) {
            var data = $.extend(otherData || {}, { UniqueIds: uniqueIds, NodeId: nodeId });
            return new Promise(function (onOk, onError) {
                jQuery.ajax({
                    method: "POST", dataType: "json", cache: false, contentType: 'application/json; charset=utf-8', url: "/umbraco/Surface/GridView/CalcFields",
                    data: kendo.stringify({ model: data }), headers,
                    success: function (result) {
                        onOk(result.Result);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        onError({ jqXHR, textStatus, errorThrown });
                    }
                });
            })
        },
        updateColumnsWidth: function (gridinfo) {

            var grid = gridinfo.kgrid,
                columns = grid.columns,
                isLocked,
                totalColwidth = 0;

            $(columns).each(function () {

                if (this.locked) isLocked = true;
                if (this.hidden != true) {
                    totalColwidth = totalColwidth + this.width;
                }
            });

        },
        updateColumnsWidthSettings: function (igridEl, settingsObj) {

            var columns = settingsObj.columns,
                totalColwidth = 0;

            $(columns).each(function () {
                if (this.hidden != true) {
                    totalColwidth = totalColwidth + this.width;
                }
                if (this.width === 0 && this.locked === true) {
                    this.width = 100;
                }
            });
            return settingsObj.columns = columns;
        },
        SuspendGridRefresh: function (grid) {
            const kendoGrid = grid.data("kendoGrid");
            if (!kendoGrid || !kendoGrid.dataSource || kendoGrid.options.originalEvents)
                return false;

            kendoGrid.options.originalEvents = {
                dsChange: kendoGrid.dataSource._events.change ? [...kendoGrid.dataSource._events.change] : [],
                dataBound: kendoGrid._events.dataBound ? [...kendoGrid._events.dataBound] : []
            };
            kendoGrid.dataSource.unbind("change");
            kendoGrid.unbind("dataBound");

            return true;
        },
        ResumeGridRefresh: function (grid) {
            const kendoGrid = grid.data("kendoGrid");
            if (!kendoGrid || !kendoGrid.dataSource || !kendoGrid.options.originalEvents)
                return false;

            const originalEvents = kendoGrid.options.originalEvents;
            if (originalEvents) {
                originalEvents.dsChange.forEach(handler => kendoGrid.dataSource.bind("change", handler));
                originalEvents.dataBound.forEach(handler => kendoGrid.bind("dataBound", handler));
            }

            delete kendoGrid.options.originalEvents;
            return true;
        },
    };

    function HideContainerGridsQuickSearches() {
        $('[data-parent-sectionid]').each(function () {
            var $section = $(this);
            var sectionId = $section.data("parent-sectionid") == undefined ? "0" : $section.data("parent-sectionid");
            var $childGrids = $("#" + sectionId).find("[class^='entity-grid']");
            if (!$childGrids.length) {
                self.HideSectionQuickSearch(sectionId);
            }
            else {
                self.HideSubQuickSearches(sectionId);
            }
        });
    };

    function HideRelatedGridsQuickSearches(relatedGridsIdis) {
        $(relatedGridsIdis).each(function (i, val) {
            //hide local grid's quicksearches
            //"[data-slide='" + current + "']"
            $("[data-nid='" + val + "']").find(".quick-search-container").hide();
        });
    };

    function SearchByContainerGrids(parentSectionId, input) {
        var childGrids = $("#" + parentSectionId).find("[class^='entity-grid']");
        if (childGrids.length) {
            childGrids.each(function (index, element) {
                XPortal.Grid.SetQuickSearch($(element), input);
            });
        }
    };

    function SearchByRelatedGrids(relatedGridsIdis, input) {
        $.each(relatedGridsIdis, function (i, val) {
            let grid = $("#entity-grid-" + val);
            if (grid != null)
                XPortal.Grid.SetQuickSearch($(grid), input);
        });
    };

    function getGridViewFieldValue(gridInfo, data, fsttgs) {
        if (gridInfo && fsttgs) {
            var fname = fsttgs.field.toLowerCase();
            try {
                var format = fsttgs.formatString ? fsttgs.formatString.replace(/\"/g, '\\"') : '';
                var gctdata = XPortal.Grid.GetTemplateValue(data, (fsttgs.type || "").toLowerCase(), encodeURIComponent(fname), encodeURIComponent(format), gridInfo.nodeId);
                return $(gctdata).html();
            } catch (ex) {
                if (console) console.log("can't get grid content view field data error:" + ex, { gridInfo, data, fsttgs });
            };
        }
        return XPortal.Template.GetObjPropValueByName(data, fsttgs.field);
    };
    function getGridColumnValue(gridInfo, data, fsttgs) {
        if (gridInfo && fsttgs) {
            var fname = fsttgs.field.toLowerCase();
            var gc = gridInfo.kgrid.columns.find(x => (x.field || "").toLowerCase() == fname);
            if (gc) {
                try {
                    var gctemplate = kendo.template(gc.template);
                    var gctdata = gctemplate(data);
                    return $(gctdata).html();
                } catch (ex) {
                    if (console) console.log("can't get grid column data error:" + ex, { gridInfo, data, fsttgs });
                };
            }
        }
        return XPortal.Template.GetObjPropValueByName(data, fsttgs.field);
    };
    function getGridDataRow(gridInfo, partEl) {
        if (gridInfo == null || gridInfo.grid == null || partEl == null) return null;
        var isGridEl = gridInfo.grid[0].contains(partEl[0]);
        if (!isGridEl) return null;
        return partEl.closest("tr");
    };
    function getGridDataRowByListDataRow(gridInfo, partEl) {
        if (gridInfo == null || gridInfo.list == null || partEl == null) return null;
        var isListEl = gridInfo.list[0].contains(partEl[0]);
        if (!isListEl) return null;
        var iUniqueId = partEl.closest(".entity-cvitem").attr("data-u-uid");
        return !iUniqueId ? null : getGridRowsByUniqueId(gridInfo.grid, iUniqueId, true);
    };
    function getGridRowsByUniqueId(grid, iUniqueId, lockedAndUnlocked, selectedids) {
        var dataObjG = !iUniqueId ? null : grid.data("kendoGrid").dataSource.data().find(x => XPortal.Template.GetObjPropValueByName(x, "uniqueid") === iUniqueId);
        return getGridRowsByUid(grid, XPortal.Template.GetObjPropValueByName(dataObjG, "uid"), lockedAndUnlocked, selectedids);
    };
    function getGridRowsByUid(grid, rowid, lockedAndUnlocked, selectedids) {
        let result = [];
        if (selectedids) {
            if (selectedids.find(function (eid) { return eid == rowid; })) return result;
            selectedids.push(rowid);
        }
        grid.find("table tbody tr").each(function () {
            var tri = $(this);
            if (tri.attr("data-uid") == rowid) {
                if (lockedAndUnlocked || result.length == 0)
                    result.push($(this));
            }
        });
        return result;
    };
    function getListRowsByUniqueId(list, iUniqueId, lstItemSelectr) {
        lstItemSelectr = lstItemSelectr || ".entity-cvitem";
        var result = [];
        list.find(lstItemSelectr).each(function () {
            if ($(this).attr("data-u-uid") == iUniqueId) result.push(this);
        });
        return $(result);
    };

    function columnJQueryValidate(input) {
        if (!input || input.length === 0) return true;

        var cell = input.closest("td.k-edit-cell");
        var validationContainer = cell.find(".grid-cell-validation-form");
        return validationContainer.length > 0 ? XPortal.Validation.ValidateElement(input, validationContainer) : true;
    };
    function updateGridInfo(existing, rgritInfo) {
        existing.parent = rgritInfo.parent;
        existing.kgrid = rgritInfo.kgrid;
        existing.klist = rgritInfo.klist;
        return existing;
    };
    function isOrphanedTransport(ginfo, dstransport) {
        if (!dstransport) return false;
        if (dstransport._fromBatchExport || typeof dstransport.CustomFilter === "function") return false;
        var kgrid = self.GetGridInfo(ginfo.grid).kgrid;
        if (!kgrid || !kgrid.dataSource) return false;
        return kgrid.dataSource.transport !== dstransport;
    };
    function isStaleGridData(sdata, ginfo, dstransport) {
        if (dstransport) return isOrphanedTransport(ginfo, dstransport);
        return sdata.requestId != ginfo.data.requestId;
    };
    function getSearchRequest(options, ginfo, pageData, relationFilter) {
        if (relationFilter) {
            if (!options.data.filter) options.data.filter = { logic: "and" };
            if (!options.data.filter.filters) options.data.filter.filters = [];
            options.data.filter.filters.push(relationFilter);
        }
        self.dictionaryParent[ginfo.nodeId] = pageData.details.parentInfo;
        var mainQueryKeywords = self.GetKeywords(ginfo.parent.find(".btn-quick-search"));
        var facets = XPortal.Facets.GetAllFacets(ginfo.id);
        var treeFacets = XPortal.Facets.GetAllTreeFacets(ginfo.id);
        var sRequest = self.ExtendRequestedParams(pageData, options.data, ginfo.kgrid.dataSource.group(), ginfo.kgrid.dataSource.options.schema.model, mainQueryKeywords, facets, treeFacets);
        if (!sRequest.pageSize && ginfo && ginfo.kgrid && ginfo.kgrid.dataSource) {
            var total = ginfo.kgrid.dataSource.total();
            if (total > 0) sRequest.pageSize = total;
        }
        sRequest.dynamicFilters = XPortal.DynamicFilters.GetFor(ginfo.nodeId, sRequest);
        ginfo.kgrid.options.filters = {
            facets: sRequest.facets,
            treeFacets: sRequest.treeFacets,
            dynamicFilters: sRequest.dynamicFilters
        };
        return sRequest;
    };
    function getGridCalendarInformationBy(xdata, ginfo) {
        return new Promise((resolve, reject) => {
            XPortal.GridCalendar.GetParentIds(ginfo.grid, xdata, ginfo.nodeId).then(function (data) {
                var options;
                var calendarArray = [];
                var parentIds = [];
                for (var key in data.Childs) {
                    calendarArray = calendarArray.concat(data.Childs[key]);
                    parentIds.push(key);
                }
                XPortal.Utils.APIPost("/umbraco/Surface/GridView/GetDataSourceByIds", { model: { EntityAlias: ginfo.entityAlias, NodeId: ginfo.nodeId, PageIndex: 1, PageSize: 10000000, ElementIds: parentIds } }, { contentType: 'application/json' })
                    .then(function (xdata) { resolve(xdata); })
                    .fail(function (jqXHR, textStatus, errorThrown) { reject(options, jqXHR, textStatus, errorThrown); });
            });
        });
    };
    function getGridHeaders(ginfo, topDetailParentInfo) {
        //request verification token+form data
        var headers = {};
        $.each(ginfo.parent.children("input:hidden"), function (ix, ixel) {
            var xel = $(ixel);
            if (xel.attr("name")) headers[xel.attr("name")] = xel.val();
        });
        headers["RequestVerificationToken"] = XPortal.Main.getAntiForgeryToken();
        if (topDetailParentInfo) {
            const pGFboxRel = ginfo.parent.children(".section-rel-parentinfo");
            const pDFboxRel = ginfo.grid.closest(".detailblock-viewcontainer");
            const dFbParentGridId = pDFboxRel.attr("data-src-id") || "";
            const gFbParentGridId = pGFboxRel.attr("data-parentid") || "";
            if (!gFbParentGridId || dFbParentGridId == gFbParentGridId) {
                headers["nParentInfo"] = topDetailParentInfo;
            }
        }
        return headers;
    };
    function successGetGridData(xdata, xdataRequest, ginfo, options, dstransport) {
        const pageData = ginfo.kgrid.options.pageData;
        const result = ginfo.kgrid.options;
        return new Promise((resolve, reject) => {
            if (!ginfo.kgrid) return;
            var sdata = XPortal.Grid.ConvertToKendoData(xdata, options, result);
            sdata.requestId = xdata.requestId;
            var isBulk = dstransport._fromBatchExport; //here is options for switch off additional ajax call durind excel/csv export
            if (typeof dstransport.CustomFilter === "function") {
                //there is special logic to handle result data 
                sdata = dstransport.CustomFilter(sdata, xdataRequest, xdata);
            } else
                XPortal.GridActions.UnbindTableEventHandlers(ginfo.grid);
            if (isBulk)
                updateCalcFieldsData(false, ginfo, sdata).then(function () {
                    options.success(sdata);
                    resolve();
                });
            else {
                var psdata = sdata;
                XPortal.Grid.GetLookupData(sdata, ginfo.grid, result, pageData)
                    .then(function (lookupData) {
                        if (isStaleGridData(sdata, ginfo, dstransport)) return;
                        sdata = lookupData == null ? sdata : XPortal.Grid.ConvertLookupData(lookupData, sdata, result);
                        ginfo.grid.trigger("grid.afterRequest", [ginfo.grid, xdataRequest, sdata, xdata]);
                        updateCalcFieldsData(true, ginfo, sdata).then(function () {
                            if (isStaleGridData(sdata, ginfo, dstransport)) return;
                            options.success(sdata);
                            XPortal.GridActions.BindTableEventHandlers(ginfo.grid);
                            if (sdata && !isBulk) {
                                var requestParameters = self.PrepareDownloadCellsMark(ginfo.grid, xdata.Requested.NodeId, result.columns, sdata);
                                if (requestParameters) XPortal.Utils.MarkVisited(requestParameters);
                                XPortal.Notificator.GetSubscriptionsFor(ginfo, { Items: psdata, EntityAlias: "PortalNotifications" }, true);
                            }
                            if (XPortal.GridCalendar.GetGridCalendarOptions(ginfo.nodeId).isExtendedGrid) {
                                XPortal.GridCalendar.InitChildEntity(ginfo.grid, xdata, ginfo.nodeId);
                            }
                            XPortal.Grid.ResizeGrid(ginfo.grid);
                            resolve();
                        });
                    })
                    .always(function () {
                        ginfo.grid.trigger("grid.onsearch", xdataRequest);
                    });
            }
        });
    };
    var calcCache = {};
    function updateCalcFieldsData(immediately, ginfo, sdata) {
        var dateSt = new Date();
        return new Promise(function (onOk, onErr) {
            ginfo = self.GetGridInfo(ginfo.grid);
            var calcFields = ginfo.kgrid ? ginfo.kgrid.options.columns.filter(x => x.isCalc) : null;
            if (!calcFields || !calcFields.length) return onOk(sdata);
            var creq = calcCache[ginfo.id] = calcCache[ginfo.id] || { tout: 0 };
            var parentInfo = decodeURIComponent((ginfo.kgrid.options.pageData.details || {}).parentInfo);
            clearTimeout(creq.tout);
            creq.tout = setTimeout(function () {
                if (sdata.requestId != ginfo.data.requestId) return;
                self.ExecuteUpdateCalcFieldsData((sdata || []).map(x => XPortal.Template.GetObjPropValueByName(x, "uniqueid")), ginfo.kgrid.options.pageData.nodeId, { EntityAlias: ginfo.grid.attr("entityalias"), parentInfo }, getGridHeaders(ginfo))
                    .then(function (result) {
                        if (sdata.requestId != ginfo.data.requestId) return;
                        if (self.showDebugInfo) console.log("calc data loaded: " + (new Date() - dateSt));
                        var xdata = !result || !result.Items ? [] : result.Items.map(di => XPortal.Grid.MapEntity(di, ginfo.kgrid.options));
                        xdata.requestId = sdata.requestId;
                        unionWithCalcFields(immediately, calcFields, sdata, xdata, result, ginfo)
                        then(function (udata) { !immediately ? onOk(udata) : udata; });
                    });
            }, 750);
            if (immediately) onOk(sdata);
        });
    };
    function unionWithCalcFields(immediately, calcFields, odata, calcdata, r, ginfo) {
        const dateSt = new Date();
        const fnames = calcFields.map(x => (x.field || x.name || x.Field || x.Name || "").toLowerCase());
        const toObjUpdate = [];
        odata = immediately ? ginfo.kgrid.dataSource.data() : odata;
        return new Promise(function (onOk, onErr) {
            calcdata.forEach((cv, cvi) => {
                const cid = XPortal.Template.GetObjPropValueByName(cv, "UniqueId");
                const ov = odata.find(ovx => XPortal.Template.GetObjPropValueByName(ovx, "UniqueId") == cid);
                if (!ov) return;
                const dbefore = ov.dirty;
                const toUpdate = {};
                fnames.forEach(cvi => {
                    if (ov[cvi] == cv[cvi]) return;
                    toObjUpdate.push({ ov, toUpdate });
                    toUpdate[cvi] = cv[cvi];
                });
                if (!immediately) XPortal.Utils.updateKendoObj(ov, toUpdate);
            });
            if (!immediately && self.showDebugInfo) {
                console.log("union-calc-end: " + (new Date() - dateSt), { calcFields, odata, calcdata });
                return onOk(odata);
            }
            else {
                let itrtn = 0;
                XPortal.Utils.waitFor(() => {
                    if (calcdata.requestId != ginfo.data.requestId) return true;
                    if (toObjUpdate.length < 1) {
                        if (self.showDebugInfo) console.log("" + itrtn + ". union-calc-end: " + (new Date() - dateSt), { calcFields, odata, calcdata });
                        onOk(odata);
                        return true;
                    };
                    itrtn++;
                    var x = toObjUpdate.pop();
                    XPortal.Utils.updateKendoObj(x.ov, x.toUpdate);
                    return false;
                }, XPortal.Utils.waitFor, 1, 100);
            }
        });
    };
    function toggleListNoRecords(ginfo) {
        const klist = ginfo.klist;
        if (!klist) return;

        klist.content.find('.k-grid-norecords').remove();

        if (klist.dataSource.view().length === 0) {
            const html = ginfo.kgrid ? ginfo.kgrid.noRecordsTemplate({}) : 'No records';
            $('<div class="k-grid-norecords"></div>').append(html).appendTo(klist.content);
        }
    };

    function successGetGridDataFinal(ginfo) {
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.GRID_DATALOADED, model: ginfo.modelName });
        // XPortal.Loader.hide({ selector:  ginfo.parent});
        if (!ginfo.kgrid) return;
        XPortal.GridActions.updateActionStates(ginfo.kgrid, ginfo);
        XPortal.Grid.BindCustomElements(ginfo.grid, ginfo.kgrid.options, ginfo.kgrid.options.pageData);

        if (ginfo.klist) {
            if (!ginfo.klist._noRecBound) {
                ginfo.klist.bind('dataBound', () => toggleListNoRecords(ginfo));
                ginfo.klist._noRecBound = true;
            }
            toggleListNoRecords(ginfo);
        }

        XPortal.Notificator.MarkAssignedNotifications(ginfo);
    };
    function patchFilter(filter, datamodel) {

        var field = _.find(datamodel.fields, function (f) { return f.field === filter.field });
        if (!field) return filter;
        var ftype = (field.type.toLowerCase() || "").toLowerCase();
        var fconvertor = (field.convertor || "").toLowerCase();
        if (ftype === "date" || fconvertor === "Date") {
            // custom filters like today this week, etc.
            var advancedOp = XPortal.GridFiltering.AdditionalGridOperators.find(op => op.value === filter.value);
            if (!advancedOp) filter.value = XPortal.Template.todate(filter.value, field.format);
        }
        if (ftype === "datetime" || fconvertor === "datetime") {
            if (filter.additionalType != "period") {
                filter.value = XPortal.Template.todate(filter.value, field.format);
            }
        }
        return filter;
    };



    function preventServiseColumnResizing(e) {
        var fieldName = $(e.currentTarget).data("th").data("field");
        if (fieldName == "selectable") {
            e.preventDefault();
            setTimeout(function () {
                $(e.currentTarget).closest(".k-grid").data("kendoGrid").wrapper.removeClass("k-grid-column-resizing");
                $(document.body).add(".k-grid th").css("cursor", "");
            });
        }
    };

    function hightligtRow(e) {
        var $trs = $(e.delegateTarget).find('table tbody tr[role="row"]');
        var i = $(this).index() + 1;
        $trs.filter(':nth-child(' + i + ')').addClass('k-state-hover');

        $(e.delegateTarget).find("thead th[role='columnheader']").removeClass("resizing");
    };

    function unhightligtRow(e) {
        var $trs = $(e.delegateTarget).find('table tbody tr[role = "row"]');
        var i = $(this).index() + 1;
        $trs.filter(':nth-child(' + i + ')').removeClass('k-state-hover');
    };

    function ColTagsNotEditable(target) {
        target.columns.forEach(function (column) {
            const fields = target.dataSource.schema.model.fields;
            let field = fields[column.field];
            if (fields.hasOwnProperty(column.field) && field.formatExtended) {
                if (field.formatExtended.Method == "XPortal.Format.Tags") {
                    column.caneditorg = column.canedit;
                    column.cancreateorg = column.cancreate;
                    column.cancreate = false;
                    column.canedit = false;
                }

            }
        });
    };

    function updateGridSize() {
        var $jobj = $('.entity-grid');
        $jobj.each(function () {
            var $this = $(this);
            if ($this.is(':visible') || $this.next('.entity-list').is(':visible') || $this.closest('.k-pane-wrapper').next('.entity-list').is(':visible'))
                XPortal.Grid.ResizeGrid($this);
        });
    };
    return self;
}());

